module.exports = __webpack_public_path__ + "static/Remohab_JP-a019951f2ceb6b9666eaa3e8861238aa.mp4";